module.exports = __webpack_public_path__ + "img/rmxqLb_banner.776b4da.png";